export default {
  cancelButtonLabel: 'CANCEL',
  continueButtonLabel: 'CONTINUE',
  searchButtonLabel: 'Search',
  searchInputPlaceholder: 'Search by name',
  searchResultsLabel: 'Found %count% matching contacts',
  searchResultLabel: 'Found 1 matching contact',
  title: 'Find a Contact'
};
